import { Capacitor } from '@capacitor/core'

export default {
    mounted() {
        this.$event.$on('page-loaded', () => {
            this.timeout = setTimeout(() => {
                this.pageLoading = false
                this.$event.$emit('layout-loaded')
            }, 200)
        })

        if (Capacitor.isNativePlatform()) {
            document.body.classList.add('capacitor')
        }
    },

    data() {
        return {
            pageLoading: true,
        }
    },
}
